import Keycloak from 'keycloak-js';
import React from 'react';
import config from '../config';

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
export const keycloak = new Keycloak({
    url: config.keycloakAuthURL,
    realm: config.keycloakRealm,
    clientId: config.keycloakClientId,
});

// This represents the keycloak object of an authenticated user.
// So far, these are the 3 fields that we use and "should" be present whenever user authenticated
export type AuthenticatedKeycloak = Keycloak & {
    authenticated: true;
    token: string;
    subject: string;
};

export interface AuthenticatedProps {
    keycloak: AuthenticatedKeycloak;
}

export type AuthenticatedComponent<T = {}> = React.FC<AuthenticatedProps & T>;

export const isAuthenticated = (
    keycloak: Keycloak | AuthenticatedKeycloak,
): keycloak is AuthenticatedKeycloak => {
    return keycloak.authenticated === true;
};

export const CONFIGURE_2FA_KC_ACTION = 'CONFIGURE_TOTP';
